import type { SupplierIndustryKind } from '@tandemone/types'
import { createContext } from 'react'

import type {
  EnumPickerCommonAction,
  EnumPickerDerived,
  EnumPickerState
} from './enum-picker'

export type IndustryRowState = {
  selected: boolean
  yearsInBusiness: number
}

export type IndustriesFormState = EnumPickerState<
  SupplierIndustryKind,
  IndustryRowState
>

export type IndustriesFormAction =
  | EnumPickerCommonAction<SupplierIndustryKind>
  | { type: 'setYears'; kind: SupplierIndustryKind; years: number }

export type IndustriesDerived = EnumPickerDerived<SupplierIndustryKind>

export type IndustriesFormContextValue = {
  state: IndustriesFormState
  derived: IndustriesDerived
  dispatch: React.Dispatch<IndustriesFormAction>
  isSubmitting: boolean
  handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void
}

export const IndustriesFormContext =
  createContext<IndustriesFormContextValue | null>(null)
